import request from "../lib/request";

interface IGetResorts {
    params : {
        page : number,
        posts_per_page? : number
    }
}
interface IInfiniteGetResorts {
    parameters : {
        page : number,
        destination? : string,
        posts_per_page? : number,
        size? : number
    }
    
}

const ResortService = () => {

    const getResorts = (data : IGetResorts) => {

        return request({
            method : 'GET',
            url : '/wp-json/api/v1/resort',
            params : data.params
        })
    }

    const getInfiniteResorts = (data : IInfiniteGetResorts) => {

        return request({
            method : 'GET',
            url : `/wp-json/api/v1/resort`,
            params : data.parameters,
        })
    }

    return { getResorts,getInfiniteResorts }

}

export default ResortService